<template>
    <div ref="observer-element">
        <slot name="loading" v-if="state === 'loading'"></slot>
        <slot name="completed" v-if="state === 'completed'"></slot>
    </div>
</template>

<script>
    export default {
        inject: ['$events'],

        data () {
            return {
                state: 'observing'
            }
        },

        mounted () {
            this.$events.$on('InertiaInfinteLoading:loaded', (e) => {
                this.state = 'observing';
            });

            this.$events.$on('InertiaInfinteLoading:complete', (e) => {
                this.state = 'completed';
            });

            this.stateChanger = {
                loaded: () => {
                    this.$events.$emit('InertiaInfinteLoading:loaded', { target: this });
                },
                complete: () => {
                    this.$events.$emit('InertiaInfinteLoading:complete', { target: this });
                },
                reset: () => {
                    this.$events.$emit('InertiaInfinteLoading:reset', { target: this });
                }
            };

            var observer = new IntersectionObserver((entries) => {
                if(entries[0].isIntersecting === true && this.state === 'observing') {
                    this.state = 'loading';
                    this.$emit('in-view', this.stateChanger);
                }
            }, { threshold: [0] });

            observer.observe(this.$refs['observer-element']);
        }
    }
</script>
